var _radialGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficTotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c7y29nzwia",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5vv6sdf2b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    transform: "translate(-8523 -11790)",
    style: {
      fill: "url(#c7y29nzwia)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    transform: "translate(8523 11790)",
    style: {
      clipPath: "url(#e5vv6sdf2b)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 89",
    d: "M123-81v-95h20v95zm-28 0v-82h20v82zm-28 0v-100h20v100zm-28 0v-85h20v85zm-28 0v-68h20v68z",
    transform: "translate(-8526 -11572)",
    style: {
      fill: "#fff6d7",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 90",
    d: "M67-121v-54.9h20v54.9zm-28 0v-61.25h20V-121zm-28 0v-38.3h20v38.3zm112 0v-61.956h20V-121zm-28 0v-55.174h20V-121z",
    transform: "translate(-8526 -11532)",
    style: {
      fill: "#fff6d7",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 91",
    d: "M123-152v-24.87h20V-152zm-28 0v-34.809h20V-152zm-28 0v-18.366h20V-152zm-28 0v-36.313h20V-152zm-28 0v-23.956h20V-152z",
    transform: "translate(-8526 -11501)",
    style: {
      fill: "#fdda5f",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficTotal);
export default __webpack_public_path__ + "static/media/traffic-total.9b6aec3ccb4d01f03d941aa5a37d788e.svg";
export { ForwardRef as ReactComponent };